export const Check = (data) => {
    
    if (data.numerosocio.trim() === "") {
      return ({ value: 1, msg: "Proporciona tu numero de socio", title: "Datos personales"}) 
    }
    if(data.apellidopaterno.trim() === "" ){
      return ({ value: 1, msg: "Debes proporcionar tu Apellido Paterno", title: "Datos personales"}) 
    }
    if(data.apellidomaterno.trim() === "" ){
      return ({ value: 1, msg: "Debes proporcionar tu Apellido Materno", title: "Datos personales"}) 
    }
    if(data.nombre.trim() === "" ){
      return ({ value: 1, msg: "Debes proporcionar tu Nombre", title: "Datos personales"}) 
    }
    // if(data.registrofederal.trim() === "" ){
    //   return ({ value: 1, msg: "Debes proporcionar tu RFC", title: "Datos personales"}) 
    // }
    if (data.curp.trim() === "") {
      return ({ value: 1, msg: "Debes proporcionar tu CURP", title: "Datos personales"}) 
    }
    if(data.domicilio.trim() === "" ){
      return ({ value: 1, msg: "Debes proporcionar tu domicilio", title: "Datos personales"}) 
    }
    if (data.colonia.trim() === "") {
      return ({ value: 1, msg: "Debes proporcionar tu colonia de residencia.", title: "Datos personales"}) 
    }
    if(data.ciudad.trim() === "" ){
      return ({ value: 1, msg: "Debes proporcionar tu ciudad de procedencia", title: "Datos personales"}) 
    }
    if(data.estado.trim() === "" ){
      return ({ value: 1, msg: "Debes seleccionar un estado", title: "Datos personales"}) 
    }
    if(data.codigopostal.trim() === "" ){
      return ({ value: 1, msg: "Debes proporcionar el codigo postal de tu domicilio", title: "Datos personales"}) 
    }
    if(data.comprobantedomicilio.trim() === ""){
      return ({ value: 1, msg: "Debes proporcionar una imagen o documento de algun comprobante de domicilio", title: "Datos personales"}) 
    }

    if(data.telefono.trim() === "" ){
      return ({ value: 1, msg: "Debes proporcionar tu telefono", title: "Datos personales"}) 
    }
    if(data.email.trim() === "" ){
      return ({ value: 1, msg: "Debes proporcionar tu email", title: "Datos personales"}) 
    }

    if(data.sucursalid === 0 ){
      return ({ value: 1, msg: "Selecciona la sucursal donde se realizarar el contacto", title: "Datos personales"}) 
    }

    if(data.identificacionfrente.trim() === ""){
      return ({ value: 1, msg: "Debes proporcionar una imagen de el frente de tu identificacion oficial", title: "Datos personales"}) 
    }
    if(data.identificacionreverso.trim() === ""){
      return ({ value: 1, msg: "Debes proporcionar una imagen de el reverso de tu identificacion oficial", title: "Datos personales"}) 
    }

    // if(data.tciudad.trim() === "" ){
    //   return ({value: 2, msg: "Por favor selecciona el tiempo que llevas viviendo en la ciudad", title: "Datos domiciliarios"}) 
    // }
    // if(data.tipovivienda.trim() === "" ){
    //   return ({value: 2, msg: "Por favor selecciona el tipo de vivienda en donde resides", title: "Datos domiciliarios"})
    // }
    // if(data.tdomicilio.trim() === "" ){
    //   return ({value: 2, msg: "Por favor seleccion el tiempo qe tiene de vivir en el domicilio", title: "Datos domiciliarios"})
    // }
    //! COMPROBACIONES COMENTADAS PUEDE SER QUE LA PERSONA NO TENGA ALGUNO DE ESTOS ELEMENTOS
    // if(parseFloat(data.casavalue) === 0 ){
    //   return ({value: 2, msg: "Por favor ingresa el valor estimado de la casa/departamentos a su nombre", title: "Valores estimados de bienes totalmente pagados"})
    // }
    // if(parseFloat(data.terrenosvalue) === 0 ){
    //   return ({value: 2, msg: "Por favor ingresa el valor estimado de los terrenos de su propiedad", title: "Valores estimados de bienes totalmente pagados"})
    // }
    // if(parseFloat(data.vehiculosvalue) === 0 ){
    //   return ({value: 2, msg: "Por favor ingresa el valor estimado de los vehiculos de su propiedad", title: "Valores estimados de bienes totalmente pagados"})
    // }
   
    // if(data.actividadeconomica.trim() === "" ){
    //   return ({value: 1, msg: "¿Cual es la actividad economica a la que se dedica?", title: "Otros datos"})
    // }
    // if(data.aniosexperiencia.trim() === "" ){
    //   return ({value: 1, msg: "Cuentenos cuantos años de experiencia tiene en el area de trabajo", title: "Otros datos"})
    // }

    
    // if(data.estadocivil.trim() === "" ){
    //   return ({value: 2, msg: "Seleccione su estado civil", title: "Otros datos"})
    // }
    // if(data.fechanacimiento.trim() === ""){
    //   return ({value: 2, msg: "Ingresa tu fecha de nacimiento", title: "Otros datos"})
    // }
    // if(parseInt(data.edad) < 18 ){
    //   return ({value: 2, msg: "Debes ser mayor de 18 años para poder obtener un credito", title: "Otros datos"})
    // }
    // if(data.niveleducacion.trim() === "" ){
    //   return ({value: 2, msg: "Seleccione por favor su nivel de educación", title: "Otros datos"})
    // }
    
    if(data.monto.trim() === "" ){
      return ({value: 2, msg: "Proporciona el mondo que deseas socilitar", title: "Datos del credito"})
    }
    if(data.plazopago.trim() === "" ){
      return ({value: 2, msg: "En cuantos meses deseas pagar este prestamo", title: "Datos del credito"})
    }
    if(data.finalidadprestamo.trim() === "" ){
      return ({value: 2, msg: "Describa la finalidad del prestamo", title: "Datos del credito"})
    }
    // if(data.frecuenciapago.trim() === "" ){
    //   return ({value: 2, msg: "", title: "Datos del credito"})
    // }
    // if(data.sueldoingreso < 0 || data.sueldoingreso.toString().trim() === "" ){
    //   return ({value: 2, msg: "Proporciona el sueldo neto que persibes mensualmente", title: "Ingresos mensuales"})
    // }
    
    // if(parseFloat(data.otrosingreso) < 0 || data.otrosingreso.toString().trim() === ""){
    //   return ({value: 2, msg: "Si existen otros ingresos por favor ingresa el monto de lo contrario solo ingresa 0", title: "Ingresos mensuales"})
    // }
    // if(parseFloat(data.ingresototal) < 0){
    //   return ({value: 2, msg: "Proporciona tus ingresos por concepto de sueldo y otros ingresos para calcular los ingresos mensuales", title: "Ingresos mensuales"})
    // }
    
    // if(parseFloat(data.saldodisponiblecredito) < 0 || data.saldodisponiblecredito.toString().trim() === "" ){
    //   return ({value: 2, msg: "", title: "Calculo de la capacidad de pago para pre-aprobacion de creditos"})
    // }
    
    // if (data.tipovivienda === "RENTADA" && data.viviendgasto < 500 ) {
    //     return ({value: 2, msg: "Si tu vivienda es rentada debes de especificar cuanto es lo que gastas en renta mensualmente.", title: "Gastos de la unidad familiar"})
    // }
    

    //! < AREA PARA MENSAJES DE GASTOS >

    /*
    if(data.gs_vivienda.toString().trim() === ''){
      return({value: 2, msg: "Si no percibes gastos de algún rubro debes de ingresar un valor 0 en donde no percibas los gastos.", tittle: "Gastos de la unidad familiar"})
    }
    if(data.gs_entretenimientodig.toString().trim() === ''){
      return({value: 2, msg: "Si no percibes gastos de algún rubro debes de ingresar un valor 0 en donde no percibas los gastos.", tittle: "Gastos de la unidad familiar"})
    }
    if(data.gs_alimentacion.toString().trim() === ''){
      return({value: 2, msg: "Si no percibes gastos de algún rubro debes de ingresar un valor 0 en donde no percibas los gastos.", tittle: "Gastos de la unidad familiar"})
    }
    if(data.gs_movil.toString().trim() === ''){
      return({value: 2, msg: "Si no percibes gastos de algún rubro debes de ingresar un valor 0 en donde no percibas los gastos.", tittle: "Gastos de la unidad familiar"})
    }
    if(data.gs_aseo.toString().trim() === ''){
      return({value: 2, msg: "Si no percibes gastos de algún rubro debes de ingresar un valor 0 en donde no percibas los gastos.", tittle: "Gastos de la unidad familiar"})
    }
    if(data.gs_transporte.toString().trim() === ''){
      return({value: 2, msg: "Si no percibes gastos de algún rubro debes de ingresar un valor 0 en donde no percibas los gastos.", tittle: "Gastos de la unidad familiar"})
    }
    if(data.gs_vehiculo.toString().trim() === ''){
      return({value: 2, msg: "Si no percibes gastos de algún rubro debes de ingresar un valor 0 en donde no percibas los gastos.", tittle: "Gastos de la unidad familiar"})
    }
    if(data.gs_salud.toString().trim() === ''){
      return({value: 2, msg: "Si no percibes gastos de algún rubro debes de ingresar un valor 0 en donde no percibas los gastos.", tittle: "Gastos de la unidad familiar"})
    }
    if(data.gs_agua.toString().trim() === ''){
      return({value: 2, msg: "Si no percibes gastos de algún rubro debes de ingresar un valor 0 en donde no percibas los gastos.", tittle: "Gastos de la unidad familiar"})
    }
    if(data.gs_entretenimiento.toString().trim() === ''){
      return({value: 2, msg: "Si no percibes gastos de algún rubro debes de ingresar un valor 0 en donde no percibas los gastos.", tittle: "Gastos de la unidad familiar"})
    }
    if(data.gs_predial.toString().trim() === ''){
      return({value: 2, msg: "Si no percibes gastos de algún rubro debes de ingresar un valor 0 en donde no percibas los gastos.", tittle: "Gastos de la unidad familiar"})
    }
    if(data.gs_vestimenta.toString().trim() === ''){
      return({value: 2, msg: "Si no percibes gastos de algún rubro debes de ingresar un valor 0 en donde no percibas los gastos.", tittle: "Gastos de la unidad familiar"})
    }
    if(data.gs_luz.toString().trim() === ''){
      return({value: 2, msg: "Si no percibes gastos de algún rubro debes de ingresar un valor 0 en donde no percibas los gastos.", tittle: "Gastos de la unidad familiar"})
    }
    if(data.gs_impuestospension.toString().trim() === ''){
      return({value: 2, msg: "Si no percibes gastos de algún rubro debes de ingresar un valor 0 en donde no percibas los gastos.", tittle: "Gastos de la unidad familiar"})
    }
    if(data.gs_gas.toString().trim() === ''){
      return({value: 2, msg: "Si no percibes gastos de algún rubro debes de ingresar un valor 0 en donde no percibas los gastos.", tittle: "Gastos de la unidad familiar"})
    }
    if(data.gs_otrosgastos.toString().trim() === ''){
      return({value: 2, msg: "Si no percibes gastos de algún rubro debes de ingresar un valor 0 en donde no percibas los gastos.", tittle: "Gastos de la unidad familiar"})
    }
  */
    //! < / AREA PARA MENSAJES DE GASTOS >

    return ({value: 0, msg: "todo bien"}) //* return to send data
    
    

}